import { render, staticRenderFns } from "./ddqjtj.vue?vue&type=template&id=d430bf06&scoped=true&"
import script from "./ddqjtj.vue?vue&type=script&lang=js&"
export * from "./ddqjtj.vue?vue&type=script&lang=js&"
import style0 from "./ddqjtj.vue?vue&type=style&index=0&id=d430bf06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d430bf06",
  null
  
)

export default component.exports